module.exports = __webpack_public_path__ + "img/wc.fc28199.svg";